/// <reference path="../wpt.ts" />
var WPTNamespace;
(function (WPTNamespace) {
    var Widgets;
    (function (Widgets) {
        const LOG_CATEGORY = "WPT.Widgets.SearchBar";
        class SearchBarWidgetTypeClass extends Widgets.WidgetTypeBaseClass {
            constructor(core, widgets, widgetName, config, layout, readyCallback = null) {
                super(core, widgets, widgetName, config, layout, readyCallback);
                this.createInstance = (config) => {
                    this._log.info("SearchBarWidgetTypeClass.createInstance()");
                    return new SearchBarWidgetInstanceClass(this._core, this, this._widgets, config, this._originatingLayout);
                };
                this._storeHtml = (htmlData) => {
                    this._log.info("SearchBarWidgetTypeClass._storeHtml()");
                    SearchBarWidgetInstanceClass.HtmlData = htmlData;
                    this._presentInstances();
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("SearchBarWidgetTypeClass::constructor");
                if (SearchBarWidgetInstanceClass.HtmlData != null) {
                    // make async call in order to get the instances created first
                    window.setTimeout(this._presentInstances, 0);
                }
                else {
                    core.Loader.getVersionedHTML('widgets/SearchBar/search-bar.html', this._storeHtml, this._core.Helper.missingHtmlErrorCallback);
                }
            }
        }
        Widgets.SearchBarWidgetTypeClass = SearchBarWidgetTypeClass;
        class SearchBarWidgetInstanceClass extends Widgets.WidgetInstanceBaseClass {
            constructor(core, type, widgets, config, layout) {
                super(core, type, widgets, config, layout);
                // Config/data
                this._instanceSelector = null;
                this._typedConfig = null;
                this._registerEmptyQueries = false;
                this._buttonWithSelect = false;
                this._allowEmptySearch = false;
                this._suppressNoDocumentsModal = false;
                this._loader = null;
                this._publishAsQuery = true;
                this._publishAsHitList = false;
                // UI Components
                this._form = null;
                this._activeButtonContainer = null;
                this._searchButton = null;
                this._typeSelectHolder = null;
                this._inputContainer = null;
                this._keyInput = null;
                this._optionInput = null;
                this._keywordOptions = null;
                this.presentInstance = () => {
                    this._log.info("SearchBarWidgetInstanceClass.presentInstance()");
                    this._container.innerHTML = SearchBarWidgetInstanceClass.HtmlData;
                    this._prepareErrorBanner();
                    // Sanity check
                    if ((!this._typedConfig.hasOwnProperty('Query') || (this._typedConfig.Query == null))
                        && (!this._typedConfig.hasOwnProperty('FlexQuery') || (this._typedConfig.FlexQuery == null))) {
                        console.warn("SearchBarWidgetInstanceClass - No query defined, cannot execute search");
                        this.addError(this._core.Locale.getTranslation('STR_WPT_QUERY_MISSING'));
                    }
                    this._loader = this._container.querySelector('.wpt-hourglass');
                    this._form = this._container.querySelector('#searchBarContent');
                    if (this._buttonWithSelect)
                        this._activeButtonContainer = this._container.querySelector('#searchBarButtonWithSelect');
                    else
                        this._activeButtonContainer = this._container.querySelector('#searchBarButtonWithInput');
                    this._searchButton = this._activeButtonContainer.querySelector('.searchbar__button');
                    this._typeSelectHolder = this._container.querySelector('#searchBarKeySelectHolder');
                    this._inputContainer = this._container.querySelector('#searchBarInputContainer');
                    this._core.Helper.prepareHourglassIcon(this._loader);
                    this._widgets.setTitle(this._config, this._container.querySelector('#searchBarHeading'), 'STR_WPT_SEARCH');
                    this._widgets.setCollapseState(this._config, this._instanceSelector);
                    this._widgets.addCollapseEventListener(this);
                    this._widgets.setWidgetHeight(this._config, this._container);
                    this._widgets.setSuppressBorder(this._config, this._container);
                    this._widgets.setSuppressHeading(this._config, this._container);
                    this._core.Helper.setElementTranslation(this._loader.querySelector('#basicSearchProcessing'), 'STR_WPT_PROCESSING');
                    this._core.Helper.setElementTranslation(this._container.querySelector('#searchBarKeySelectLabel'), 'STR_WPT_SEARCH_USING');
                    this._searchButton.addEventListener('click', this._searchClicked);
                    this._keywordOptions = {
                        Items: []
                    };
                    let optionConfig = {
                        Options: this._keywordOptions,
                        ValueMustExist: true,
                        AllowEmptyValue: false,
                        ChangeCallback: this._keyTypeSelected
                    };
                    this._optionInput = new Widgets.ComponentOptionInput(this._core, this._typeSelectHolder, this, optionConfig);
                    this._optionInput.present();
                    this._optionInput.Input.id = "searchBarKeySelect";
                    this._core.Functions.showElement(this._activeButtonContainer);
                    this._core.OBHelper.LoadKeywordTypes(this._populateSelect);
                    this._type.instanceReady(this.getHandle());
                };
                this._callFailedHandler = (json) => {
                    this._log.info("SearchBarWidgetInstanceClass._callFailedHandler()");
                    let response = json;
                    this.addError(response.Connection.Message);
                };
                this._callErrorHandler = (url, status, message) => {
                    this._log.info("SearchBarWidgetInstanceClass._callErrorHandler()");
                    this.addError(message);
                };
                this._populateSelect = () => {
                    this._log.info("SearchBarWidgetInstanceClass._populateSelect()");
                    // Sanity check
                    if (this._typedConfig.hasOwnProperty('Keywords') && (this._typedConfig.Keywords != null) && (this._typedConfig.Keywords.length > 0)) {
                        this._keywordOptions = {
                            Items: []
                        };
                        this._typedConfig.Keywords.forEach(kwName => {
                            let keyType = this._core.OBHelper.KeywordTypeMap[kwName];
                            if (keyType) {
                                let keyTypeOption = {
                                    Id: keyType.Name,
                                    DisplayName: keyType.TranslatedName
                                };
                                this._keywordOptions.Items.push(keyTypeOption);
                            }
                            else
                                console.warn(`SearchBarWidgetInstanceClass - Requested keyword type '${kwName}' not found.'`);
                        });
                        this._optionInput.Options = this._keywordOptions;
                        this._optionInput.Input.value = this._keywordOptions.Items[0].DisplayName;
                        this._optionInput.Input.dispatchEvent(new Event('change'));
                    }
                    else {
                        console.warn("SearchBarWidgetInstanceClass - No search keywords configured");
                        this.addError(this._core.Locale.getTranslation('STR_WPT_KEYWORDS_MISSING'));
                        this._searchButton.disabled = true;
                    }
                };
                this._keyTypeSelected = (event) => {
                    this._log.info("SearchBarWidgetInstanceClass._keyTypeSelected()");
                    this._inputContainer.innerHTML = '';
                    let id = WPTNamespace.MetadataEditors.KeywordEditor.CounterString;
                    let displayValue = this._optionInput.Input.value;
                    let selectedKeyType = this._keywordOptions.Items.find(opt => opt.DisplayName == displayValue);
                    let keyType = this._core.OBHelper.KeywordTypeMap[selectedKeyType === null || selectedKeyType === void 0 ? void 0 : selectedKeyType.Id];
                    if (keyType) {
                        this._keyInput = WPTNamespace.MetadataEditors.KeywordEditor.CreateEditor(this._core, this._form, this._inputContainer, id, keyType, '', WPTNamespace.MetadataEditors.KeywordEditMode.SEARCH);
                        this._keyInput.Placeholder = this._core.Locale.getTranslation('STR_WPT_SEARCH_VALUE');
                        this._keyInput.KeyUpHandler = this._enterEventListener;
                        this._searchButton.disabled = false;
                    }
                    else {
                        console.warn(`SearchBarWidgetInstanceClass - Selected keyword type '${selectedKeyType === null || selectedKeyType === void 0 ? void 0 : selectedKeyType.Id}' not found.'`);
                        this.addError(this._core.Locale.getTranslation('STR_WPT_UNKNOWN_KEYWORD_SELECTED'));
                        this._searchButton.disabled = true;
                    }
                };
                this._enterEventListener = (event) => {
                    this._log.info("SearchBarWidgetInstanceClass._enterEventListener()");
                    if (event.key === 'Enter') {
                        this._searchClicked(null);
                    }
                };
                this._searchClicked = (event) => {
                    this._log.info("SearchBarWidgetInstanceClass._searchClicked()");
                    event === null || event === void 0 ? void 0 : event.preventDefault();
                    if (this._form.reportValidity()) {
                        this._optionInput.hideOptions();
                        // Convert to flexSearch for working
                        let flex = null;
                        if (this._typedConfig.Query) {
                            if (typeof this._typedConfig.Query !== 'object') {
                                flex = {
                                    Type: "customquery",
                                    Terms: [{ Term: ">>customquery", Value: this._typedConfig.Query }]
                                };
                            }
                            else
                                flex = this._core.OBHelper.compileFlexSearchFromQueryDef(this._typedConfig.Query).SearchDefinition;
                        }
                        else {
                            flex = JSON.parse(JSON.stringify(this._typedConfig.FlexQuery));
                        }
                        if (!flex.hasOwnProperty('Terms') || (flex.Terms == null))
                            flex.Terms = [];
                        let displayValue = this._optionInput.Input.value;
                        let selectedKeyType = this._keywordOptions.Items.find(opt => opt.DisplayName == displayValue);
                        if (this._keyInput.Value)
                            flex.Terms.push({ Term: selectedKeyType === null || selectedKeyType === void 0 ? void 0 : selectedKeyType.Id, Value: this._keyInput.Value });
                        // Run the actual query
                        if (this._log.isTraceEnabled()) {
                            this._log.trace(`SearchBar attempting query - kw '${selectedKeyType === null || selectedKeyType === void 0 ? void 0 : selectedKeyType.Id}'', value '${this._keyInput.Value}', allowEmpty: ${this._allowEmptySearch}`);
                        }
                        if ((selectedKeyType === null || selectedKeyType === void 0 ? void 0 : selectedKeyType.Id) && (this._keyInput.Value || this._allowEmptySearch)) {
                            if (this._publishAsQuery) {
                                let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_DEFINITION);
                                navEvent.ActivationID = 0;
                                navEvent.PrimaryContext = flex;
                                let targetLayoutName = "DocumentList";
                                if (this._typedConfig.hasOwnProperty("LaunchLayout") && this._typedConfig.LaunchLayout) {
                                    if (this._typedConfig.LaunchLayout == "[[CURRENT]]")
                                        targetLayoutName = this._currentLayout;
                                    else
                                        targetLayoutName = this._typedConfig.LaunchLayout;
                                }
                                // Add transfer widgets if we are moving
                                if (targetLayoutName != this._currentLayout) {
                                    if (this._typedConfig.hasOwnProperty("ForwardOtherWidgets")) {
                                        navEvent.populateTransferList(this._typedConfig.ForwardOtherWidgets, this._core);
                                    }
                                }
                                navEvent.Layout = targetLayoutName;
                                this._core.Navigation.Details.requestActivation(navEvent);
                            }
                            if (this._publishAsHitList) {
                                this._searchInProgress();
                                let requestSearch = this._core.OBHelper.flexDefinitionToRequest(flex);
                                this._core.Loader.genericServiceCallWithData('/Documents.svc/rest/DocumentQuery', JSON.stringify(requestSearch), this._receiveHitList.bind(this, requestSearch.SearchDefinition), {}, this._callErrorHandler, this._callFailedHandler);
                            }
                        }
                        else {
                            console.warn('SearchBarWidgetInstanceClass - Cannot query without keyword type and value');
                            this.addError(this._core.Locale.getTranslation('STR_WPT_REQUIRED_SEARCH_KEYS_MISSING'));
                        }
                    }
                };
                this._receiveHitList = (searchDef, response) => {
                    this._log.info("SearchBarWidgetInstanceClass._receiveHitList()");
                    this._searchComplete();
                    if (response.hasOwnProperty('Documents') && (response.Documents != null) && (response.Documents.length > 0)) {
                        let config = this._config;
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_RESULT_DOCUMENTS);
                        navEvent.PrimaryContext = response.Documents;
                        navEvent.AdditionalContext["FlexSearch"] = searchDef;
                        let targetLayoutName = "DocumentList";
                        if (config.hasOwnProperty("LaunchLayout") && config.LaunchLayout) {
                            if (config.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = config.LaunchLayout;
                        }
                        // Add transfer widgets if we are moving
                        if (targetLayoutName != this._currentLayout) {
                            if (config.hasOwnProperty("ForwardOtherWidgets")) {
                                navEvent.populateTransferList(config.ForwardOtherWidgets, this._core);
                            }
                        }
                        navEvent.Layout = targetLayoutName;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                    else
                        this._emptyQueryReceived();
                };
                this._emptyQueryReceived = () => {
                    this._log.info("SearchBarWidgetInstanceClass._emptyQueryReceived()");
                    if (!this._suppressNoDocumentsModal) {
                        this._core.Helper.presentMessageModal(WPTNamespace.ModalType.FIRST, 'STR_WPT_NO_DOCS_FOUND');
                    }
                    if (this._registerEmptyQueries) {
                        let navEvent = new WPTNamespace.Navigation.ActivationContext(this, WPTNamespace.Navigation.LayoutActivationType.QUERY_NO_DOCUMENTS);
                        navEvent.ActivationID = 0;
                        navEvent.PrimaryContext = null;
                        // Set default layout, but check if we've had an alternative requested against the instance
                        let targetLayoutName = this._currentLayout;
                        if (this._typedConfig.hasOwnProperty("LaunchLayout") && this._typedConfig.LaunchLayout) {
                            if (this._typedConfig.LaunchLayout == "[[CURRENT]]")
                                targetLayoutName = this._currentLayout;
                            else
                                targetLayoutName = this._typedConfig.LaunchLayout;
                        }
                        // Add transfer widgets if we are moving
                        if (targetLayoutName != this._currentLayout) {
                            if (this._typedConfig.hasOwnProperty("ForwardOtherWidgets")) {
                                navEvent.populateTransferList(this._typedConfig.ForwardOtherWidgets, this._core);
                            }
                        }
                        navEvent.Layout = targetLayoutName;
                        this._core.Navigation.Details.requestActivation(navEvent);
                    }
                };
                this._searchInProgress = () => {
                    this._log.info("SearchBarWidgetInstanceClass._searchInProgress()");
                    this._core.Functions.showElement(this._loader);
                    this._searchButton.disabled = true;
                };
                this._searchComplete = () => {
                    this._log.info("SearchBarWidgetInstanceClass._searchComplete()");
                    this._core.Functions.hideElement(this._loader);
                    this._searchButton.disabled = false;
                };
                this._log = this._core.Logging.getLogger(LOG_CATEGORY);
                this._log.info("SearchBarWidgetInstanceClass::constructor");
                this._instanceSelector = config.PlaceHolder;
                this._container = document.querySelector(this._instanceSelector);
                this._typedConfig = this._config;
                if (this._typedConfig.hasOwnProperty("RegisterEmptyQueries") && (this._typedConfig.RegisterEmptyQueries))
                    this._registerEmptyQueries = true;
                if (this._typedConfig.hasOwnProperty("PlaceButtonWithSelect") && (this._typedConfig.PlaceButtonWithSelect))
                    this._buttonWithSelect = true;
                if (this._typedConfig.hasOwnProperty("AllowEmptySearch") && (this._typedConfig.AllowEmptySearch))
                    this._allowEmptySearch = true;
                if (this._typedConfig.hasOwnProperty("SuppressNoDocumentsMessage") && (this._typedConfig.SuppressNoDocumentsMessage))
                    this._suppressNoDocumentsModal = true;
                if (this._typedConfig.hasOwnProperty('PublishAsQuery') && (this._typedConfig.PublishAsQuery != null))
                    this._publishAsQuery = this._typedConfig.PublishAsQuery;
                if (this._typedConfig.hasOwnProperty('PublishAsHitList') && (this._typedConfig.PublishAsHitList != null))
                    this._publishAsHitList = this._typedConfig.PublishAsHitList;
            }
        }
        SearchBarWidgetInstanceClass.HtmlData = null;
        Widgets.SearchBarWidgetInstanceClass = SearchBarWidgetInstanceClass;
    })(Widgets = WPTNamespace.Widgets || (WPTNamespace.Widgets = {}));
})(WPTNamespace || (WPTNamespace = {}));
